<template>
  <div class="pa0 ma0">
    <a @click=handleProjectClick(project.id) class="cursor dim">
      <pro-project-thumbnail-photo :project="project" :width="280"></pro-project-thumbnail-photo>
    </a>
    <div class="flex items-center">
      <div class="flex-auto">
        <h3 class="f4 fw6 mb0 pb0">
          <a @click=handleProjectClick(project.id) class="dim near-black hover-black cursor">{{project.name | truncate(40)}}</a>
          <span class="f5" v-if="!project.publiclyViewable">(Private)</span>
        </h3>
      </div>
    </div>
    <div class="flex flex-wrap items-center justify-between pt2 pb4">
        <div class="v-mid flex items-center">
          <div class="mr3 dib silver flex items-center">
            <img src="/img/view-icon.svg" alt="Views">
            <div class="pl2">{{project.viewCount}}</div>
          </div>
          <div class="mr3 dib silver flex items-center">
            <img src="/img/like-icon.svg" alt="Likes">
            <div class="pl2">{{project.likeCount}}</div>
          </div>
        </div>
        <div v-if="showButtons">
          <a @click="handleProjectClick(project.id)" class="gray hover-gray ba f4 pa2 br2 b--black-10 bg-animate hover-bg-near-white cursor">View</a>
          <a :href="'/pro/project/' + project.id + '?form'" class="gray hover-gray ba f4 pa2 br2 b--black-10 bg-animate hover-bg-near-white cursor">Edit</a>
        </div>
    </div>
    <pro-project-details-modal @modalClose="showModal=false" v-if="showModal" :profile-link-target="profileLinkTarget"></pro-project-details-modal>
  </div>
</template>

<script>

    import proProjectThumbnailPhoto from './ProProjectThumbnailPhoto'
    import proProjectDetailsModal from './ProProjectDetailsModal'
    import proProjectReactionForm from './ProProjectReactionForm'
    import projectService from '../../../../api/ProjectService'
    import { mapState } from 'vuex'

    export default {
        name: 'ProProjectCard',
        components: { proProjectThumbnailPhoto, proProjectDetailsModal, proProjectReactionForm },
        props: {
            project: {
                type: Object,
                required: true,
            },
            showDetailsOnRender: {
                type: Boolean,
                default: false,
                required: false,
            },
            showButtons: {
                type: Boolean,
                required: false,
                default: false
            },
            profileLinkTarget: {
                type: String,
                default: '_self',
                required: false,
            },
        },
        computed : {
            ...mapState(['env']),
        },
        data() {
            return {
                showModal: false
            }
        },
        methods: {
            handleProjectClick(projectToShowId) {
                console.log(projectToShowId);
                this.showModal=true;
                projectService.getProject(projectToShowId).then(response => {
                    this.$modal.show('pro-project-details-modal',
                        {
                            project: response.data,
                            previewMode: false,
                        });
                });
            },
        },

        created() {
            if(this.showDetailsOnRender) {
                this.handleProjectClick(this.project.id);
            }

        },

        filters: {
            truncate: function(value, limit) {
                if (value.length > limit) {
                    value = value.substring(0, (limit - 3)) + '...';
                }

                return value
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/project/components/ProProjectCard.vue